import {createSlice} from "@reduxjs/toolkit";
import _ from "lodash";

const alertsSlice = createSlice({
    name: 'alerts',
    initialState: {
        alerts: [],
    },
    reducers: {
        setAlert(state, action) {
            let alerts = [...state.alerts]
            alerts.push(action.payload)
            state.alerts = alerts;
        },

        hideAlert(state, action) {
            let i = _.findIndex(state.alerts, function (o) {
                return o.key === action.payload;
            });
            if (i < 0) {
                return;
            }

            let alerts = [...state.alerts]
            alerts[i].display = false;
            state.alerts = alerts;
        },
    }
});

/**
 *
 * @param alert
 * @param alert.type success / error / warning / info
 * @param alert.header Head of the alert. fallback exists.
 * @param alert.body text of the alert
 * @param alert.duration duration of the alert on screen in seconds
 * @param alert.hideClose hides the close button if set to true
 *
 * @returns {(function(*): Promise<(function(): void)|undefined>)|*}
 */
export const setAlert = (alert) => {
    if (!alert) {
        console.error('[!] No alert provided to setAlert() function')
    }
    return async (dispatch) => {
        try {
            alert.duration = alert.duration ? alert.duration * 1000 : 5 * 1000;
            alert.key = Math.floor(Math.random() * 1000000);
            alert.display = true;
            await dispatch(alertsActions.setAlert(alert));

            let timer = setTimeout(async () => {
                await dispatch(alertsActions.hideAlert(alert.key));
            }, alert.duration)

            return () => {
                clearInterval(timer);
            };
        } catch (e) {
            console.error(e);
        }
    }
}

export const removeAlert = (key) => {
    return async (dispatch) => {
        try {
            dispatch(alertsActions.hideAlert(key));
        } catch (e) {
            console.error(e);
        }
    }
}


export const alertsActions = alertsSlice.actions;
export default alertsSlice.reducer;
